import React from 'react';
import { IoAlarmOutline } from '@react-icons/all-files/io5/IoAlarmOutline';

import { decorateComponent } from '../../../documentComponents';
import { ImageMapBraze } from './ImageMapBraze';
import { ImageMapBrazeInspector } from './ImageMapBraze.Inspector';

export default decorateComponent(ImageMapBraze, 'block', {
  id: 'imageMapBraze',
  label: '이미지 영역 braze 알림 로깅',
  disabledMove: true,
  allowedParent: ['image'],
  allowedChildren: [],
  disallowedAncestors: [
    'a',
    'coupon',
    'tabButton',
  ],
  defaultProps: {
    message: '신청이 완료되었습니다',
    style: {
      top: '25%',
      left: '25%',
      width: '50%',
      height: '50%',
    },
  },
  renderIcon: () => <IoAlarmOutline />,
  renderInspector: ImageMapBrazeInspector,
});
